import * as i0 from '@angular/core';
import { InjectionToken, NgModule, inject, APP_INITIALIZER } from '@angular/core';
import { enableTyduxDevelopmentMode, createTyduxStore, setGlobalStore, TyduxStore } from '@w11k/tydux';

const tyduxModuleConfiguration = new InjectionToken("TyduxModuleConfiguration");
class TyduxModule {
    constructor() {
    }
    static forRootWithConfig(config) {
        return {
            ngModule: TyduxModule,
            providers: provideTydux(config)
        };
    }
    static forRootWithoutConfig() {
        return {
            ngModule: TyduxModule,
            providers: provideTydux()
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.0.4", ngImport: i0, type: TyduxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.0.4", ngImport: i0, type: TyduxModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.0.4", ngImport: i0, type: TyduxModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.0.4", ngImport: i0, type: TyduxModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: function () { return []; } });
function factoryTyduxStore() {
    const configFactory = inject(tyduxModuleConfiguration) ?? {};
    const config = typeof configFactory === "function" ? configFactory() : configFactory;
    const initialState = Object.assign({}, config.preloadedState);
    if (config.developmentMode === undefined && config.environment !== undefined && !config.environment.production) {
        enableTyduxDevelopmentMode(config);
    }
    else if (config.developmentMode === true) {
        enableTyduxDevelopmentMode(config);
    }
    const tyduxStore = createTyduxStore(initialState, {
        name: config.name,
        reducer: config.reducer,
        enhancer: config.enhancer,
    });
    if (config.skipGlobalStoreRegistration !== true) {
        setGlobalStore(tyduxStore);
    }
    return tyduxStore;
}
function provideTydux(config) {
    return [
        { provide: TyduxStore, useFactory: factoryTyduxStore },
        { provide: tyduxModuleConfiguration, useValue: config ?? {} },
        { provide: APP_INITIALIZER, useFactory: () => (store) => store, multi: true, deps: [TyduxStore] }
    ];
}

/**
 * Generated bundle index. Do not edit.
 */

export { TyduxModule, factoryTyduxStore, provideTydux, tyduxModuleConfiguration };
